/**
 * Booking Notes Form
 * All fields are editable
 */

import { useTranslation } from 'react-i18next';
import { StickyNote } from 'lucide-react';
import type { Database } from '../lib/database.types';

type Booking = Database['public']['Tables']['bookings']['Row'];

interface BookingNotesFormProps {
  booking: Booking;
  onChange: (updates: Partial<Booking>) => void;
  disabled: boolean;
}

export default function BookingNotesForm({ booking, onChange, disabled }: BookingNotesFormProps) {
  const { t } = useTranslation();
  return (
    <div className="space-y-lg">
      {/* Internal Notes */}
      <div>
        <h3 className="text-lg font-semibold text-primary mb-md flex items-center gap-xs">
          <StickyNote className="w-5 h-5 text-blue" />
          {t('bookingNotes.internalNotes')}
        </h3>
        <div>
          <label className="block text-sm font-medium text-primary mb-xs">
            {t('bookingNotes.staffOnlyNotes')}
          </label>
          <textarea
            value={booking.internal_notes || ''}
            onChange={(e) => onChange({ internal_notes: e.target.value })}
            disabled={disabled}
            className="input w-full"
            rows={4}
            placeholder={t('bookingNotes.placeholder')}
          />
          <p className="text-xs text-secondary mt-xs">
            {t('bookingNotes.notVisibleToCustomers')}
          </p>
        </div>
      </div>
    </div>
  );
}
